import { ReactNode } from 'react';
import { MenuItem, MenuRadioGroup } from '@szhsin/react-menu';

import IconCheck from '@/icons/Check.svg';

export const FilterRadioItem = ({ value, children }: { value: string; children: ReactNode }) => {
  return (
    <MenuItem
      type="radio"
      value={value}
      onClick={(e) => {
        e.keepOpen = true;
      }}
    >
      {children}
      <IconCheck />
    </MenuItem>
  );
};

export function FilterRadioGroup<T>({
  value,
  onChange,
  children,
}: {
  value: T;
  onChange?: (value: T) => void;
  children: ReactNode;
}) {
  return (
    <MenuRadioGroup value={value} onRadioChange={(e) => onChange?.(e.value as typeof value)}>
      {children}
    </MenuRadioGroup>
  );
}
